import { ContentType } from '@creditsights/api-ui-web';
import { TreeNodeModel } from '@creditsights/styleguide-web';
import { CSViewOption, FilterGroups, FilterType, IssuersFilterOption, RiskFilterType } from '../../models';
import {
  AcrTierMetric,
  DeteriorationImprovementMetric,
  DifferentialMetric,
  HighLowBriefCreditRiskLevelMetric,
  HighLowCreditRiskLevelMetric,
  // MiscStateMetric,
  PositiveNegativeCreditRiskLevelMetric,
} from '../../services/dtos/riskProducts/creditRiskLevels.dto';
import { convertRiskOptionsToTreeModel } from '../../utils/filterUtils';
import { WeightingType } from '../WeightIcon/WeightIcon';

const COMPANY_QUICK_FILTERS: IssuersFilterOption[] = [
  FilterType.region,
  FilterType.country,
  FilterType.sector,
  FilterType.creditGrade,
  CSViewOption,
  FilterType.assetClass,
  FilterType.currency,
];

export const COMPANY_RISK_FILTERS: IssuersFilterOption[] = [
  RiskFilterType.cqs,
  RiskFilterType.cqs_trend_1y,
  RiskFilterType.cqs_trend_3y,
  RiskFilterType.cqs_outlook,
  RiskFilterType.cqs_volatility,
  RiskFilterType.acr_level_4,
  RiskFilterType.cqd,
  RiskFilterType.fas,
  // RiskFilterType.country_risk,
  RiskFilterType.cre_1y,
  RiskFilterType.credit_risk_level,
  RiskFilterType.credit_risk_trend_6m,
  // RiskFilterType.misc,
  RiskFilterType.total_debt,
  RiskFilterType.total_assets,
];

const positiveNegativeValues = Object.values(PositiveNegativeCreditRiskLevelMetric).filter(
  (v) => v !== PositiveNegativeCreditRiskLevelMetric.NOT_AVAILABLE
);
const highLowValues = Object.values(HighLowCreditRiskLevelMetric).filter(
  (v) => v !== HighLowCreditRiskLevelMetric.NOT_AVAILABLE
);
const differentialValues = Object.values(DifferentialMetric).filter((v) => v !== DifferentialMetric.NOT_AVAILABLE);
const acrTierValues = Object.values(AcrTierMetric).filter((v) => v !== AcrTierMetric.NOT_AVAILABLE);
const highLowBriefValues = Object.values(HighLowBriefCreditRiskLevelMetric);
const deteriorationValues = Object.values(DeteriorationImprovementMetric);
// const miscStateValues = Object.values(MiscStateMetric);

export const RISK_FILTER_OPTIONS: Array<[IssuersFilterOption, string[]]> = [
  [RiskFilterType.cqs_trend_1y, deteriorationValues],
  [RiskFilterType.cqs_trend_3y, deteriorationValues],
  [RiskFilterType.cqs_outlook, positiveNegativeValues],
  [RiskFilterType.cqs_volatility, highLowBriefValues],
  [RiskFilterType.fas, highLowValues],
  [RiskFilterType.cqd, differentialValues],
  [RiskFilterType.acr_level_4, acrTierValues],
  [RiskFilterType.credit_risk_level, highLowValues],
  [RiskFilterType.credit_risk_trend_6m, deteriorationValues],
  // [RiskFilterType.misc, miscStateValues],
];

export const RISK_FILTERS_OPTION_TREE_MAP: Map<IssuersFilterOption, TreeNodeModel[]> = new Map(
  RISK_FILTER_OPTIONS.map(([key, values]) => [key, convertRiskOptionsToTreeModel(values)])
);

export const COMPANY_FILTER_GROUPS: FilterGroups = {
  quickFilters: COMPANY_QUICK_FILTERS,
  riskFilters: COMPANY_RISK_FILTERS,
};

export const RANGE_FILTER_TYPES: IssuersFilterOption[] = [
  RiskFilterType.cqs,
  RiskFilterType.cre_1y,
  // RiskFilterType.country_risk,
  RiskFilterType.total_debt,
  RiskFilterType.total_assets,
];

// export const DISABLED_FILTER_TYPES: IssuersFilterOption[] = [RiskFilterType.country_risk, RiskFilterType.misc];
export const DISABLED_FILTER_TYPES: IssuersFilterOption[] = [];

export const LEVEL_3_FILTER_TYPES: IssuersFilterOption[] = [
  RiskFilterType.fas,
  RiskFilterType.credit_risk_level,
  RiskFilterType.credit_risk_trend_6m,
];

export const FILTERS_WITHOUT_SEARCH: IssuersFilterOption[] = [
  FilterType.creditGrade,
  CSViewOption,
  FilterType.assetClass,
];

export const CS_VIEW_DATA = [
  {
    key: WeightingType.Buy,
    title: 'Buy',
  },
  {
    key: WeightingType.Outperform,
    title: 'Outperform',
  },
  {
    key: WeightingType.Marketperform,
    title: 'Market perform',
  },
  {
    key: WeightingType.Hold,
    title: 'Hold',
  },
  {
    key: WeightingType.Underperform,
    title: 'Underperform',
  },
  {
    key: WeightingType.Sell,
    title: 'Sell',
  },
  {
    key: WeightingType.NoRecommendation,
    title: 'No Recommendation',
  },
];

export enum Coverage {
  CS = 'cs',
  CR = 'cr',
  LFI = 'lfi',
  Financials = 'financials',
  RiskProducts = 'riskProducts',
}

export type CoverageItem = {
  id: Coverage;
  contentType: ContentType;
  testId: string;
};

export const COVERAGE_ITEMS: CoverageItem[] = [
  { id: Coverage.CS, contentType: ContentType.Research, testId: 'research-coverage-button' },
  { id: Coverage.CR, contentType: ContentType.Covenants, testId: 'covenants-coverage-button' },
  { id: Coverage.LFI, contentType: ContentType.News, testId: 'news-coverage-button' },
  { id: Coverage.Financials, contentType: ContentType.Financials, testId: 'financials-coverage-button' },
  { id: Coverage.RiskProducts, contentType: ContentType.RiskProducts, testId: 'risk-products-coverage-button' },
];
